import { render, staticRenderFns } from "./IndicadorPresupuestosPropuestosConfirmados.vue?vue&type=template&id=56f9f88a&"
import script from "./IndicadorPresupuestosPropuestosConfirmados.vue?vue&type=script&lang=js&"
export * from "./IndicadorPresupuestosPropuestosConfirmados.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports